/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetDashboardOverviewParams,
  GetDashboardTimeseriesParams,
  SuccessResponseDTODashboardOverviewResponseDTO,
  SuccessResponseDTODashboardTimeseriesResponseDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * Omit days for all-time totals (deltas use a 30-day growth window). Pass days for a trailing window; activity KPIs become window-scoped and deltas compare against the prior equal-length window.
 * @summary Get platform-wide dashboard KPI totals
 */
export const getDashboardOverview = (params?: GetDashboardOverviewParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTODashboardOverviewResponseDTO>({
    url: `/admin/api/dashboard/overview`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetDashboardOverviewQueryKey = (params?: GetDashboardOverviewParams) => {
  return [`/admin/api/dashboard/overview`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardOverview>>,
  TError = unknown,
>(
  params?: GetDashboardOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardOverview>>> = ({ signal }) =>
    getDashboardOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardOverview>>
>;
export type GetDashboardOverviewQueryError = unknown;

export function useGetDashboardOverview<
  TData = Awaited<ReturnType<typeof getDashboardOverview>>,
  TError = unknown,
>(
  params: undefined | GetDashboardOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardOverview>>,
          TError,
          Awaited<ReturnType<typeof getDashboardOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardOverview<
  TData = Awaited<ReturnType<typeof getDashboardOverview>>,
  TError = unknown,
>(
  params?: GetDashboardOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardOverview>>,
          TError,
          Awaited<ReturnType<typeof getDashboardOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardOverview<
  TData = Awaited<ReturnType<typeof getDashboardOverview>>,
  TError = unknown,
>(
  params?: GetDashboardOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform-wide dashboard KPI totals
 */

export function useGetDashboardOverview<
  TData = Awaited<ReturnType<typeof getDashboardOverview>>,
  TError = unknown,
>(
  params?: GetDashboardOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDashboardOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns daily (≤30d), weekly (≤90d), or monthly buckets of new users, active users, views, content, exclusive posts, and purchases.
 * @summary Get platform dashboard activity time-series
 */
export const getDashboardTimeseries = (
  params?: GetDashboardTimeseriesParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTODashboardTimeseriesResponseDTO>({
    url: `/admin/api/dashboard/timeseries`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetDashboardTimeseriesQueryKey = (params?: GetDashboardTimeseriesParams) => {
  return [`/admin/api/dashboard/timeseries`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardTimeseriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardTimeseries>>,
  TError = unknown,
>(
  params?: GetDashboardTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardTimeseriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardTimeseries>>> = ({ signal }) =>
    getDashboardTimeseries(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardTimeseries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardTimeseriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardTimeseries>>
>;
export type GetDashboardTimeseriesQueryError = unknown;

export function useGetDashboardTimeseries<
  TData = Awaited<ReturnType<typeof getDashboardTimeseries>>,
  TError = unknown,
>(
  params: undefined | GetDashboardTimeseriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardTimeseries>>,
          TError,
          Awaited<ReturnType<typeof getDashboardTimeseries>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardTimeseries<
  TData = Awaited<ReturnType<typeof getDashboardTimeseries>>,
  TError = unknown,
>(
  params?: GetDashboardTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardTimeseries>>,
          TError,
          Awaited<ReturnType<typeof getDashboardTimeseries>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardTimeseries<
  TData = Awaited<ReturnType<typeof getDashboardTimeseries>>,
  TError = unknown,
>(
  params?: GetDashboardTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform dashboard activity time-series
 */

export function useGetDashboardTimeseries<
  TData = Awaited<ReturnType<typeof getDashboardTimeseries>>,
  TError = unknown,
>(
  params?: GetDashboardTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDashboardTimeseriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
